export const MPU_SIZE = [300, 250] as const;
export const DMPU_SIZE = [300, 600] as const;
export const BILLBOARD_SIZE = [970, 250] as const;
export const LEADERBOARD_SIZE = [728, 90] as const;
export const MOBILE_BANNER_SIZE = [320, 50] as const;
export const HOMEPAGE_DESKTOP_SIZE = [1920, 380] as const;
export const HOMEPAGE_MOBILE_SIZE = [767, 466] as const;
